import React, { useState,useContext} from "react";
import { Modal } from "react-bootstrap";
import { FileTypeEnum } from "../../../Enumeration/FileTypeEnum";
import { getFileExtenction } from "../../../Utils/FileUtils";
import "./CsplPreviewModal.css";
import { exportData } from "../../../Utils/FileExportUtils";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import {VIEW_MODE } from "../../../Utils/GlobalValues";

function CsplPreviewModal(props) {
  const[fileExtension,setFileExtension]=useState(getFileExtenction(props.fileName));
  const [sourceData, setSourceData] = useState(generatingImageData(props.base64String));
  const applicationContext = useContext(KycApplicationContext);
  

  /* get class for image preview */
  function getPreviewClass() {
    if (fileExtension === FileTypeEnum.PDF) {
      return "preview-img-pdf";
    } else {
      return "preview-img";
    }
  }

  //generate image data
  function generatingImageData(base64String) {
    let imageData='';
    if (fileExtension=== FileTypeEnum.PDF) {
      imageData = generatePDFData(base64String, imageData);          
    } else {
      imageData ="data:image/" +fileExtension.toLowerCase()  + ";base64," + base64String;      
    }
    return imageData;
  }

  //generate pdf data
  function generatePDFData(base64String, imageData) {
    const binStr = atob(base64String);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    imageData = URL.createObjectURL(new Blob([arr], { type: "application/pdf" }));
    return imageData;
  }

  /**
   * Download Preview Image Handler
   */
  function downloadPreviewImageHandler(e){
    e.preventDefault();

    //export data 
    exportData(props.base64String,props.fileName ,fileExtension.toLowerCase());
  }

  return (
    <Modal
      className="modal-background"
      show={props.showPreview}
      onHide={props.onClose}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="modalbody">
        <div>
          {/* show download icon only in view mode and not for pdf */}
          {applicationContext.mode === VIEW_MODE &&
            fileExtension !== FileTypeEnum.PDF && (
              <span
                className="downloadImgwhiteColor me-4 mb-3 padding-top-10"
                onClick={downloadPreviewImageHandler}
              />
            )}
          <span
            className="image-preview-close-button"
            onClick={props.onClose}
          ></span>
        </div>
        <object
          id="popupVideo"
          data={sourceData}
          className={getPreviewClass()}
        />
      </Modal.Body>
    </Modal>
  );


}

export default CsplPreviewModal;
